import { combineReducers } from 'redux';
import credential from './credential.reducer';

const reducer = combineReducers({
	credential
});

export default reducer;
